module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAQAAABHeoekAAAAAXNSR0IArs4c6QAAARNJREFUGBmFwc8rg3EcwPH357NRdppaTlPSVjQHq7WS8uPCH+Du5k657T/h5sDRxcFBUcpB1A4O8nyeR5qW5mcuS/Y8X89MGMrrRTevaud0UT7VU1aXUJ7s9jLNb17BnO0Rsx1zfolu3oQ52+KDrZuzWb7Ykjmr8I23Ys5fpsNW7e5inB/8vN1YBcR2mXebHMm4PNNwORFqODcovhtlkQOxbRfKAg2uyNEvVdeiBJyQoOiOqdFm114RvGk7I2ZrtkHMTr05UNhPogyAZkgScynpo61HM6CQTYAoREqHRMK7SEH5h0L+hVDvQR9oEdOmNml71UdI2pikXTaaCQindCgoQ1SgNyhDNMxkUBM7ZISIv6n4b2KTcRh0b16SAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/subOrg_icon.png
// module id = hQM2
// module chunks = 2